import { render } from "./logotypes.vue?vue&type=template&id=548f45f8"
import script from "./logotypes.vue?vue&type=script&lang=js"
export * from "./logotypes.vue?vue&type=script&lang=js"

import "./logotypes.vue?vue&type=style&index=0&id=548f45f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__